var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 610,
    height: 567,
    viewBox: "0 0 610 567",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.306 502.472H273.86C273.86 502.472 258.518 455.99 200.568 456.25C142.633 456.509 102.953 480.97 101.306 502.472ZM544.181 387.93C544.181 387.93 586.012 387.93 585.448 447.725C584.883 506.605 523.883 500.505 523.883 500.505H309.728C309.728 500.505 289.384 496.281 290.452 462.075C291.519 427.869 346.129 470.691 386.283 476.319C426.436 481.946 476.761 469.853 500.581 444.309C524.402 418.765 544.181 387.93 544.181 387.93Z",
    fill: "#F4C62C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M376.187 265.411C376.187 265.411 360.327 326.914 349.347 346.328C337.513 367.235 319.32 366.198 313.25 364.994C287.264 359.839 289.018 384.559 289.018 390.156C289.018 395.753 292.907 395.905 295.179 390.232C297.451 384.559 295.255 380.579 300.959 378.612C299.647 390.919 316.483 397.171 326.045 385.734C344.421 380.488 372.054 374.586 387.701 356.347C404.323 336.964 414.327 290.025 414.327 290.025L376.187 265.411Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 0.573839,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M379.359 271.968C379.359 271.968 382.531 285.358 391.452 292.236C400.358 299.113 405.193 302.224 405.193 302.224L406.702 287.096L379.359 271.968Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.573839,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M437.218 207.568C437.218 207.568 387.96 218.838 376.187 265.411C382.607 284.413 409.92 294.859 409.92 294.859L424.972 269.696",
    fill: "#F4C62C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M437.218 207.568C437.218 207.568 387.96 218.838 376.187 265.411C382.607 284.413 409.92 294.859 409.92 294.859L424.972 269.696",
    stroke: "#1A1A1A",
    strokeWidth: 0.573839,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M475.754 423.081C474.687 431.652 476.578 481.763 481.046 500.673H411.094C399.931 422.776 420.077 390.156 420.077 390.156H484.584",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M475.754 423.081C474.687 431.652 476.578 481.763 481.046 500.673H411.094C399.931 422.776 420.077 390.156 420.077 390.156H484.584",
    stroke: "#1A1A1A",
    strokeWidth: 0.573839,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M462.014 414.526C463.371 450.363 486.933 500.688 486.933 500.688H529.587C539.774 500.765 548.771 498.325 557.357 495C557.357 495 549.915 450.668 550.723 422.822C551.532 394.975 533.857 365.543 533.857 365.543L460.962 388.83",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M462.014 414.526C463.371 450.363 486.933 500.688 486.933 500.688H529.587C539.774 500.765 548.771 498.325 557.357 495C557.357 495 549.915 450.668 550.723 422.822C551.532 394.975 533.857 365.543 533.857 365.543L460.962 388.83",
    stroke: "#1A1A1A",
    strokeWidth: 0.573839,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M435.067 213.988C435.067 213.988 404.552 260.195 404.156 323.651C403.759 387.106 419.619 397.125 419.619 397.125C419.619 397.125 521.809 404.354 536.8 366.335C518.592 282.811 515.923 276.391 515.923 276.391L500.597 211.075",
    fill: "#1C0311"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M435.067 213.988C435.067 213.988 404.552 260.195 404.156 323.651C403.759 387.106 419.619 397.125 419.619 397.125C419.619 397.125 521.809 404.354 536.8 366.335C518.592 282.811 515.923 276.391 515.923 276.391L500.597 211.075",
    stroke: "#1A1A1A",
    strokeWidth: 0.573839,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M437.217 211.075C437.217 211.075 438.559 229.817 463.188 230.351C487.817 230.885 493.444 209.199 493.444 209.199C493.444 209.199 473.634 206.515 476.044 182.969C478.453 159.408 488.9 132.644 450.073 132.904C411.262 133.178 426.253 190.991 437.217 192.592C448.197 194.193 448.99 193.126 448.99 193.126C448.99 193.126 450.592 209.474 437.217 211.075Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 0.573839,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M493.429 203.953C493.429 203.953 469.807 265.792 473.818 300.73C477.828 335.667 481.656 399.916 505.843 403.118C530.029 406.336 546.087 365.39 546.087 354.532C546.087 343.689 522.801 270.596 524.798 248.514C526.811 226.432 520.086 219.752 520.086 219.752L493.429 203.953Z",
    fill: "#F4C62C",
    stroke: "#1A1A1A",
    strokeWidth: 0.573839,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M510.982 274.088C510.982 274.088 508.709 291.092 513.788 300.196C518.866 309.3 525.698 311.572 525.698 311.572L525.164 287.477L510.982 274.088Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.573839,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M508.603 272.639C508.603 272.639 510.036 279.959 520.818 295.377C520.65 295.713 520.528 296.124 520.421 296.612C535.839 292.281 551.699 289.277 567.635 288.911C567.178 285.282 566.705 282.308 566.37 280.264C557.54 223.641 500.581 208.178 500.581 208.178M414.327 217.099C414.327 217.099 430.675 206.973 441.701 205.951C441.701 205.951 426.847 307.638 428.052 330.071C429.257 352.504 439.551 395.875 424.972 401.898C410.393 407.922 404.765 400.526 401.959 383.751C399.153 366.976 395.051 294.92 401.105 264.755",
    fill: "#F4C62C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M508.603 272.639C508.603 272.639 510.036 279.959 520.818 295.377C520.65 295.713 520.528 296.124 520.421 296.612C535.839 292.281 551.699 289.277 567.635 288.911C567.178 285.282 566.705 282.308 566.37 280.264C557.54 223.641 500.581 208.178 500.581 208.178M414.327 217.099C414.327 217.099 430.675 206.973 441.701 205.951C441.701 205.951 426.847 307.638 428.052 330.071C429.257 352.504 439.551 395.875 424.972 401.898C410.393 407.922 404.765 400.526 401.959 383.751C399.153 366.976 395.051 294.92 401.105 264.755",
    stroke: "#1A1A1A",
    strokeWidth: 0.573839,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M567.651 288.926C551.714 289.292 535.839 292.297 520.437 296.628C522.953 304.39 524.829 315.187 527.604 324.749C513.483 319.609 472.796 316.087 457.058 314.882C457.058 314.882 449.143 310.78 449.814 306.616C450.485 302.468 447.267 293.761 444.72 293.105C442.174 292.434 441.503 295.652 443.119 299.937C440.572 296.048 429.333 290.573 424.377 291.107C419.421 291.641 419.161 307.303 420.229 312.655C421.296 318.008 438.666 328.958 438.681 328.958C446.291 333.868 467.473 346.282 516.578 367.83C575.306 393.587 571.448 318.801 567.651 288.926Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 0.573839,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M419.832 121.268C419.832 121.268 403.835 148.642 426.39 150.213C448.929 151.783 453.398 152.683 454.831 160.171C456.265 167.674 455.548 172.478 455.548 172.478C455.548 172.478 459.132 174.262 459.208 172.478C459.284 170.693 458.75 161.238 465.537 164.09C472.323 166.942 469.105 174.262 467.855 175.863C466.604 177.464 467.504 186.386 476.959 183.183C486.414 179.965 493.017 173.362 486.597 162.489C480.177 151.6 479.994 147.498 481.961 140.361C483.928 133.224 475.175 124.303 460.184 127.871C445.178 131.44 420.717 126.804 419.832 121.268Z",
    fill: "#1C0311",
    stroke: "#1A1A1A",
    strokeWidth: 0.573839,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M567.651 242.627C567.651 242.627 578.844 259.219 579.241 280.905",
    stroke: "#1A1A1A",
    strokeWidth: 0.573839,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M579.912 288.926V295.362",
    stroke: "#1A1A1A",
    strokeWidth: 0.573839,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.e0df4b693467afd03519f6413c9fd262.svg";
export { ForwardRef as ReactComponent };